module.exports = __webpack_public_path__ + "static/media/icon-change-policy-disabled.bdecd1d5.svg";